import React, { useMemo, useState } from "react";
import "./Home.css";
import logo from "../assets/elitLig_logo.png";
import defaultImage from "../assets/field.jpg";
import Header from "./Header";
import Footer from "./Footer";
import { useParams, useNavigate } from "react-router-dom";
import { useData } from "./Cache";

// URL karşılaştırmaları için normalize fonksiyonu
function normalize(str = "") {
  return str
    .toLowerCase()
    .replace(/ç/g, "c")
    .replace(/ğ/g, "g")
    .replace(/ı/g, "i")
    .replace(/ö/g, "o")
    .replace(/ş/g, "s")
    .replace(/ü/g, "u")
    .replace(/[^a-z0-9 ]/g, "")
    .trim()
    .replace(/\s+/g, "-");
}

export default function Home() {
  const { cityName, leagueName, seasonName } = useParams();
  const navigate = useNavigate();
  const { matches, teams, loading, error } = useData();

  // Sezona ait maçları filtrele
  const seasonMatches = useMemo(
    () =>
      matches.filter(
        (m) =>
          normalize(m.city) === cityName &&
          normalize(m.league_name) === leagueName &&
          normalize(m.match_season) === seasonName
      ),
    [matches, cityName, leagueName, seasonName]
  );

  // --- SLAYT: BAŞLIĞI OLAN MAÇLARI EN YENİDEN ESKİYE---
  const filteredMatches = useMemo(() => {
    return seasonMatches
      .filter((m) => m.match_title?.trim() !== "")
      .sort((a, b) => new Date(b.date) - new Date(a.date)); // en yeni önce
  }, [seasonMatches]);

  const [carouselIndex, setCarouselIndex] = useState(0);
  const currentMatch = filteredMatches[carouselIndex] || null;

  const prevMatch = () =>
    setCarouselIndex((i) => (i - 1 + filteredMatches.length) % filteredMatches.length);
  const nextMatch = () =>
    setCarouselIndex((i) => (i + 1) % filteredMatches.length);

  // Tarihe göre gruplayan yardımcı
  const groupByDate = (arr) =>
    Object.entries(
      arr.reduce((acc, m) => {
        const d = m.date.split("T")[0];
        (acc[d] = acc[d] || []).push(m);
        return acc;
      }, {})
    );

  // Fikstürler (tarihe göre, eski→yeni)
  const fixturesByDate = useMemo(
    () => groupByDate(seasonMatches.filter((m) => m.is_it_fixture)),
    [seasonMatches]
  );

  // Sonuçlar: önce tarih bazında en yeni maçı al, sonra grupla
  const resultsByDate = useMemo(() => {
    const pastMatches = seasonMatches
      .filter((m) => !m.is_it_fixture)
      .sort((a, b) => new Date(b.date) - new Date(a.date)); // en yeni önce
    return groupByDate(pastMatches);
  }, [seasonMatches]);

  // Puan durumu hesaplama
  const computeStandings = () => {
    const table = {};
    seasonMatches
      .filter((m) => !m.is_it_fixture)
      .forEach((m) => {
        const { first_team_name: H, second_team_name: A, first_team_score: HS, second_team_score: AS } = m;
        if (!table[H]) table[H] = { played: 0, wins: 0, draws: 0, losses: 0, points: 0, scored: 0, conceded: 0 };
        if (!table[A]) table[A] = { played: 0, wins: 0, draws: 0, losses: 0, points: 0, scored: 0, conceded: 0 };

        table[H].played++; table[A].played++;
        table[H].scored += HS; table[H].conceded += AS;
        table[A].scored += AS; table[A].conceded += HS;

        if (HS > AS) {
          table[H].wins++; table[H].points += 3; table[A].losses++;
        } else if (HS < AS) {
          table[A].wins++; table[A].points += 3; table[H].losses++;
        } else {
          table[H].draws++; table[A].draws++;
          table[H].points++; table[A].points++;
        }
      });

    return Object.entries(table)
      .map(([name, s]) => ({ name, ...s, average: s.scored - s.conceded }))
      .sort((a, b) => (b.points !== a.points ? b.points - a.points : b.average - a.average));
  };
  const standings = useMemo(computeStandings, [seasonMatches]);

  if (loading) return <p className="home-loading">Yükleniyor…</p>;
  if (error) return <p className="home-error">Hata: {error}</p>;

  const fmtTime = (t = "") => t.slice(0, 5);
  const fmtDate = (d) =>
    new Date(d).toLocaleDateString("tr-TR", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });

  return (
    <>
      <Header />

      {/* SLAYT ALANI */}
      <div className="hero-carousel-wrapper">
        {filteredMatches.length === 0 ? (
          <div className="image-gallery">
            <div className="image-container">
              <img src={defaultImage} alt="Default Match" />
              <p className="default-message">Maç bulunamadı</p>
            </div>
          </div>
        ) : (
          currentMatch && (
            <div className="image-gallery">
              <div className="image-container">
                <img
                  src={currentMatch.match_picture || defaultImage}
                  alt={currentMatch.match_title || "Match Image"}
                />
                <button
                  className="slide-caption"
                  onClick={() =>
                    navigate(`/${cityName}/${leagueName}/${seasonName}/maclar/${currentMatch.id}`)
                  }
                >
                  {currentMatch.match_title}
                </button>
                <button className="nav-button" onClick={prevMatch}>◀</button>
                <button className="nav-button" onClick={nextMatch}>▶</button>
              </div>
            </div>
          )
        )}
      </div>

      {/* ANA İÇERİK: Fikstür, Sonuç, Puan */}
      <div className="home-container">
        {/* FİKSTÜR */}
        <section className="home-section">
          <h2 className="home-header">Fikstür</h2>
          {fixturesByDate.map(([date, games]) => (
            <div key={date} className="date-group">
              <h3 className="date-title">{fmtDate(date)}</h3>
              <table className="home-table">
                <tbody>
                  {games.slice(0, 10).map((m) => (
                    <tr
                      key={m.id}
                      className="match-row"
                      onClick={() =>
                        navigate(`/${cityName}/${leagueName}/${seasonName}/maclar/${m.id}`)
                      }
                    >
                      <td className="team-cell">
                        <img
                          src={teams.find((t) => t.team_name === m.first_team_name)?.logo || logo}
                          alt=""
                          className="team-logo"
                        />
                        {m.first_team_name}
                      </td>
                      <td className="time-cell">{fmtTime(m.time)}</td>
                      <td className="team-cell away">
                        {m.second_team_name}
                        <img
                          src={teams.find((t) => t.team_name === m.second_team_name)?.logo || logo}
                          alt=""
                          className="team-logo"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        {/* SONUÇLAR */}
        <section className="home-section">
          <h2 className="home-header">Sonuçlar</h2>
          {resultsByDate.map(([date, games]) => (
            <div key={date} className="date-group">
              <h3 className="date-title">{fmtDate(date)}</h3>
              <table className="home-table">
                <tbody>
                  {games.slice(0, 10).map((m) => (
                    <tr
                      key={m.id}
                      className="match-row"
                      onClick={() =>
                        navigate(`/${cityName}/${leagueName}/${seasonName}/maclar/${m.id}`)
                      }
                    >
                      <td className="team-cell">
                        <img
                          src={teams.find((t) => t.team_name === m.first_team_name)?.logo || logo}
                          alt=""
                          className="team-logo"
                        />
                        {m.first_team_name}
                      </td>
                      <td className="score-cell">
                        {m.first_team_score} - {m.second_team_score}
                      </td>
                      <td className="team-cell away">
                        {m.second_team_name}
                        <img
                          src={teams.find((t) => t.team_name === m.second_team_name)?.logo || logo}
                          alt=""
                          className="team-logo"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        {/* PUAN DURUMU */}
        <section className="home-section">
          <h2 className="home-header">Puan Durumu</h2>
          <table className="home-table">
            <thead>
              <tr className="standing-row">
                <th>#</th>
                <th>Takım</th>
                <th>O</th>
                <th>G</th>
                <th>B</th>
                <th>M</th>
                <th>AV</th>
                <th>P</th>
              </tr>
            </thead>
            <tbody>
              {standings.slice(0, 21).map((t, i) => (
                <tr
                  key={t.name}
                  className="standing-row"
                  onClick={() =>
                    navigate(`/${cityName}/${leagueName}/${seasonName}/takimlar/${normalize(t.name)}`)
                  }
                >
                  <td>{i + 1}</td>
                  <td className="team-cell">
                    <img
                      src={teams.find((x) => x.team_name === t.name)?.logo || logo}
                      alt=""
                      className="team-logo"
                    />
                    {t.name}
                  </td>
                  <td>{t.played}</td>
                  <td>{t.wins}</td>
                  <td>{t.draws}</td>
                  <td>{t.losses}</td>
                  <td>{t.average}</td>
                  <td>{t.points}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </div>

      <Footer />
    </>
  );
}
